import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Text from 'components/common/Text/Text'
import { APPOINTMENT_DURATION_DISCLOSURE_TEXT } from 'components/QuickAppointmentPage/BOTDateTimeSelector/components/DateTimeSelector/constants'

const DurationInfo = React.memo(({ className }) =>
  <DurationWrapper className={ className } >
    <Text>{APPOINTMENT_DURATION_DISCLOSURE_TEXT}</Text>
  </DurationWrapper>
)

DurationInfo.propTypes = {
  className: PropTypes.string
}

export default DurationInfo

const DurationWrapper = styled.div`
  margin: 24px 0 0 0;

  & span {
    font-style: italic;
  }
`
